/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import React, { FC, useState, useEffect } from 'react'
import { KTSVG } from '../../helpers'
import { LanguageHelp } from '../../../_metronic/helpers/LanguageHelper'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import clsx from 'clsx'
import CreatableSelect from "react-select/creatable"
import makeAnimated from 'react-select/animated'
import { useThemeMode } from '../layout/theme-mode/ThemeModeProvider'

export class AutomaticallyGroupSubjectsWithAIDto { type = 1; isOnlyThoseWithoutGroups = false; }

type Props = {}
const animatedComponents = makeAnimated();
const AutomaticallyGroupSubjectsWithAIModal: FC<Props> = ({ }) => {
  const [loading, setLoading] = useState(false)

  const createChannelSchema = Yup.object().shape({
  })
  const [automaticallyGroupSubjectsWithAIDto, setAutomaticallyGroupSubjectsWithAIDto] = useState(new AutomaticallyGroupSubjectsWithAIDto())
  const { mode } = useThemeMode()

  const formik = useFormik({
    initialValues: automaticallyGroupSubjectsWithAIDto,
    // initialTouched:{ 
    //   isOnlyThoseWithoutGroups: true,
    // },
    validationSchema: createChannelSchema,
    // validateOnMount: true,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      isSuccess = false
      try {
        var isSuccess = await automaticallyGroupSubjectsWithAIModal()
        console.log(isSuccess, "isSuccess")
      } catch (ex) {
        if (ex instanceof Error) {
          toast.error(LanguageHelp(ex.message));
        } else {
          console.log("Unexpected error", ex);
        }
      } finally {
        setSubmitting(true)
        document.getElementById("buttonCreateDismiss")?.click()
        if (isSuccess == true) {
          document.body.classList.remove('modal-open')
          formik.resetForm();
        }
        setLoading(false);
      }
    },
  })

  const automaticallyGroupSubjectsWithAIModal = async () => {

    var payload = {
      isOnlyThoseWithoutGroups: formik.getFieldProps('isOnlyThoseWithoutGroups').value,
    }

    return axios
      .post(`${process.env.REACT_APP_API_URL}/reviewsubjects/AutoSubjectGoupingWithAI`, payload)
      .then((response) => {
        if (response.data.httpStatusCode === 200) {

          if (response.data.message !== null) {
            toast.warning(LanguageHelp(response.data.message));
          } else {
            toast.success(response.data.result.data.replace('subjects updated.', LanguageHelp('subjects updated.')));
          }
        } else {
          toast.error(response.data.message != null ? response.data.message : "An unexpected error has occurred");
        }
        return response.data.result;
      })
      .then((response: any) => response != null)
  }

  return (
    <div className='modal fade' id='kt_modal_AutomaticallyGroupSubjectsWithAI' aria-hidden='true'>
      {/* <div className='modal-dialog modal-xl'> */}
      <div className='modal-dialog modal-dialog-centered mw-750px'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>{LanguageHelp('Auto Group With AI')}</h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div className='btn btn-sm btn-icon btn-active-color-primary' id='buttonCreateDismiss' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
          </div>
          <div className='modal-header justify-content-end border-0 pb-0'>
            <form className='form' style={{ minWidth: "-webkit-fill-available" }} onSubmit={formik.handleSubmit} noValidate>
              {/* begin::Scroll */}
              <div
                id='kt_modal_add_user_scroll'
                data-kt-scroll='true'
              >

                {/* begin::Input group */}
                <div className='fv-row mb-7'>
                  <div className='row mb-6'>
                    <div className='col-lg-8 fv-row'>
                      <div className='form-check form-check-solid fv-row'>
                        <input
                          className='form-check-input'
                          type='checkbox'
                          {...formik.getFieldProps('isOnlyThoseWithoutGroups')}
                          checked={formik.values.isOnlyThoseWithoutGroups}
                          onChange={formik.handleChange}
                        />
                        <label className='form-check-label fw-bold ps-2 fs-6' htmlFor='isOnlyThoseWithoutGroups'>
                          {LanguageHelp('Only those without groups')}
                        </label>
                      </div>
                      {formik.touched.isOnlyThoseWithoutGroups && formik.errors.isOnlyThoseWithoutGroups && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik.errors.isOnlyThoseWithoutGroups}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* end::Input group */}

              </div>
              {/* end::Scroll */}

              {/* begin::Actions */}
              <div className='text-center pt-10 pb-5'>
                <button
                  type='submit'
                  className='btn btn-primary mb-2'
                  data-kt-multisubject-modal-action='submit'
                  disabled={formik.isSubmitting || !formik.isValid || !formik.touched}
                >

                  {!loading && (
                    <div>
                      <i className="fas fa-paper-plane"></i>
                      <span className='indicator-label'>{LanguageHelp('Submit')}</span>
                    </div>
                  )}
                  {loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {LanguageHelp('Please Wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* end::Actions */}
            </form>
          </div>
        </div></div>
    </div>
  )
}

export { AutomaticallyGroupSubjectsWithAIModal }
